import { forwardRef } from 'react';
import { cn } from '../lib/cn.js';

const VARIANTS = {
  primary: 'bg-ink text-paper border border-ink hover:bg-ink-2',
  secondary: 'bg-transparent text-ink border border-ink hover:bg-line-2',
  ghost: 'bg-transparent text-ink border border-transparent hover:bg-line-2',
};

// Tightened 2026-05-28 to match image-16 reference: ~20% shorter, lighter
// padding, sm font for non-lg. Overrides the in-tree colors_and_type.css
// (48/20/16 default) which read as too chunky against the actual designs.
const SIZES = {
  sm: 'h-8 px-3 text-sm',     // was h-[38px] px-4 text-sm
  md: 'h-10 px-4 text-sm',    // was h-12 px-5 text-base
  lg: 'h-12 px-5 text-base',  // was h-14 px-6 text-base
};

export const Button = forwardRef(function Button(
  { variant = 'primary', size = 'md', className, type = 'button', children, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex items-center justify-center gap-2 font-medium rounded-pill',
        'min-w-0 text-center leading-tight whitespace-normal',
        'transition-colors duration-color',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'focus-visible:outline-none',
        VARIANTS[variant],
        SIZES[size],
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
});
